<div class="queue-panel">
	<div class="queue-panel__header">
		<h2>File d'attente</h2>
		<button type="button" class="secondary" data-role="download-all" hidden>Tout télécharger (.zip)</button>
	</div>
	<p class="queue-panel__empty" data-role="empty">Aucun élément pour l'instant.</p>
	<ul class="queue-panel__list" data-role="list"></ul>
</div>
